interface TypographyProps {
    children: React.ReactNode;
    className?: string;
}

export const BodyBold = ({ children, className = '' }: TypographyProps) => {
    return (
        <p className={`font-outfit text-base lg:text-xl font-bold lg:font-extrabold leading-5 lg:leading-6 ${className}`}>
            {children}
        </p>
    );
};